import { useCallback } from 'react'
import { Link, Image } from '@chakra-ui/react'

export const Banner = ({ src, fallbackSrc, href, alt, gtmClick, ...props }) => {
  const imageSrc = src || fallbackSrc

  const handleError = useCallback(
    (e) => {
      if (!fallbackSrc) return

      const img = e.currentTarget
      if (img.src === fallbackSrc) {
        img.onerror = null
        return
      }
      img.onerror = null
      img.src = fallbackSrc
    },
    [fallbackSrc],
  )

  return (
    <Link href={href} {...(gtmClick && { 'data-gtm-click': gtmClick })}>
      <Image src={imageSrc} onError={handleError} alt={alt} width="100%" {...props} />
    </Link>
  )
}
